import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import { flowRight } from 'lodash';
import withViewportDetection from '../../../../config/viewport';
import { BookingSectionContainer } from './BookingSectionContainer';
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import * as Actions from './actions';

export default flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    withTheme,
    withViewportDetection,
)(BookingSectionContainer);

export { Actions };
